import { ValidateNested } from 'class-validator';
import { IssueNoteInterface } from '../database';

export class SaveIssueNoteRequestDto {
	@ValidateNested()
	public note: Partial<IssueNoteInterface>;

	public constructor(data: SaveIssueNoteRequestDto) {
		this.note = data.note;
	}
}
